import type { AppRole } from "@shared/types/roles.ts";
import { useUserContext } from "../../../context/UserContext";
import { hasRole } from "../../../lib/auth";

interface RequireRoleProps {
  role: AppRole;
  children: React.ReactNode;
  /** Rendered when the user does not hold the required role. Defaults to null. */
  fallback?: React.ReactNode;
}

/** Renders children only when the current session user holds the given role. */
export function RequireRole({ role, children, fallback = null }: RequireRoleProps) {
  const { session } = useUserContext();
  return hasRole(session?.user, role) ? <>{children}</> : <>{fallback}</>;
}
